(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('salespitch', {
            parent: 'app',
            url: '/hvorfor-velge-bestå',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/salespitch.html'
                }
            }
        })
        .state('access', {
            parent: 'app',
            url: '/tilgang',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/access.html'
                }
            }
        })
        .state('preparation', {
            parent: 'app',
            url: '/forberedelser',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/preparation.html'
                }
            }
        })
        .state('individuals', {
            parent: 'app',
            url: '/privatpersoner',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/individuals.html'
                }
            }
        })
        .state('terms_and_conditions', {
            parent: 'app',
            url: '/salgsvilkår',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/terms_and_conditions.html'
                }
            }
        });
    }
})();
